import { Popover } from 'antd'
import PropTypes from 'prop-types'
import './PopoverCommon.scss'

export const PopoverCommon = ({
	visible,
	content,
	placement,
	trigger = 'hover',
	title,
	className = '',
	mouseLeaveDelay,
	children,
	onVisibleChange,
	...props
}) => {
	if (visible !== undefined) {
		return (
			<Popover
				popupVisible={visible}
				overlayClassName={`${className} popover-common`}
				content={content}
				title={title}
				trigger={trigger}
				placement={placement}
				mouseLeaveDelay={mouseLeaveDelay}
				{...props}
			>
				{children}
			</Popover>
		)
	}

	return (
		<Popover
			overlayClassName={`${className} popover-common`}
			content={content}
			title={title}
			trigger={trigger}
			placement={placement}
			mouseLeaveDelay={mouseLeaveDelay}
			onVisibleChange={onVisibleChange}
			{...props}
		>
			{children}
		</Popover>
	)
}

PopoverCommon.propTypes = {
	content: PropTypes.node.isRequired,
	children: PropTypes.node.isRequired,
	visible: PropTypes.bool,
	trigger: PropTypes.string,
	placement: PropTypes.string,
	onVisibleChange: PropTypes.func,
}
